import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
//components
import InsWallHeader from "../../../../components/InsWallHeader/InsWallheader";
import NewPostBtn from "../../../../components/Wall/NewPostBtn";
import SquaredPost from "../../../../components/Wall/List/SquaredPost";
import InsLoader from "../../../../components/InsLoader/InsLoader";
//style
import "./WallList.scss";
//api
import { getAllPosts, getPostWithFilter } from "../../../../api/wall";
import * as actions from "../../../../store/actions/wallActions";
import InfiniteScroll from "react-infinite-scroll-component";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import Square from "components/Square/Square";

function WallList({
  wallFiltersListThemes,
  wallFiltersListBrands,
  wallFiltersList,
  setDataToRedux,
  wallFiltersListData,
}) {
  const [wallList, setWallList] = useState(null);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const wrapperEl = useRef(null);

  //Détermine le type d'icon à afficher
  function iconOption(type, filesLength) {
    if (filesLength > 1) {
      return "multipleFiles";
    } else {
      if (type === "image") {
        return "image";
      } else if (type === "video") {
        return "video";
      }
    }
    return "error";
  }

  function extensionImg(obj) {
    let extension = obj.split(".");
    extension = extension[extension.length - 1];
    return extension;
  }

  const fetchPosts = async (data) => {
    try {
      setHasMore(data.length ? true : false);
      setWallList((prev) => [...(prev || []), ...data]);
      setDataToRedux(data);
      setOffset((prev) => prev + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoading(true);

    const data = [];

    if (wallFiltersListThemes.length || wallFiltersListBrands.length) {
      const posts = await getPostWithFilter({
        ...wallFiltersList,
        offset: offset,
      });

      data.push(...posts);
    } else {
      const posts = await getAllPosts({ offset: offset });

      data.push(...posts);
    }

    setLoading(false);
    fetchPosts(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const loader = (
    <div
      style={{
        display: "flex",
        margin: "10px 0",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <LoadingSpinner loading={loading}></LoadingSpinner>
    </div>
  );

  const getPostHeight = () => {
    const width =
      document.querySelector(".squared_wrapper")?.getBoundingClientRect()
        ?.width || 0;

    return width;
  };

  return (
    <>
      <InsWallHeader />
      <div className="content_wall_list default-layout--min-height">
        {wallList ? (
          <>
            <InfiniteScroll
              dataLength={wallList.length}
              next={fetchData}
              hasMore={hasMore}
              className="wallList_wrapper"
              loader={loader}
            >
              {wallList.map((post, i) => (
                <Link
                  className="squared_wrapper"
                  key={i}
                  to={{
                    pathname: "/wall/p/" + post.id,
                    state: { transitionName: "slide_in" },
                  }}
                >
                  <Square>
                    <SquaredPost
                      height={getPostHeight()}
                      type={iconOption(post.files[0].type, post.files.length)}
                      imagePreview={post.files[0].name.name_333}
                      videoPreview={post.files[0].name.thumbnail}
                      extension={extensionImg(
                        post.files[0].name.name_333 ||
                          post.files[0].name.thumbnail
                      )}
                    />
                  </Square>
                </Link>
              ))}
            </InfiniteScroll>
            <NewPostBtn bottom="15rem" position="fixed" />
          </>
        ) : (
          <div className="loader_wall">
            <InsLoader />
          </div>
        )}
      </div>
    </>
  );
}
//extract data from the redux store
const mapStateToProps = (state) => ({
  wallFiltersList: state.wallFilters,
  wallFiltersListData: state.wallFilters.data,
  wallFiltersListThemes: state.wallFilters.themes,
  wallFiltersListBrands: state.wallFilters.brands,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setDataToRedux: (data) => {
      dispatch(actions.setData(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WallList);
